/**
 * Components entry point
 * Use this to import other modules
 * @module
 */
import './array_fields';
import './address';
import './button';
import './datepicker';
import './change';
import './dropdown';
import './form';
import './menu';
import './photo-upload';
import './tooltip';
import './register';
import './language';



// WEBPACK FOOTER //
// ./src/my_artis/js/components/index.js